<template>
    <EspSolutionTypeMedia :spot="spot" :eventId="eventId" :userId="userId" :teamId="teamId" :maxSize="25600"  @input="onInput"/>
</template>

<script>
    import {layoutMixin} from '@/utils/layout-mixin'
    import EspSolutionTypeMedia from '@/components/spots/EspSolutionTypeMedia.vue'

    export default {
        mixins:[layoutMixin],
        components: {
            EspSolutionTypeMedia,
        },
        props:{
            spot:{},
            eventId:{},
            userId:{},
            teamId:{}
        },
        data() {
            return {
            }
        },

        methods: {
            onInput(filename,data){
                this.$emit('input',filename,data);
            }
        },
    }
</script>